import { render, staticRenderFns } from "./normalDialog.vue?vue&type=template&id=3e113bd8&scoped=true&"
import script from "./normalDialog.vue?vue&type=script&lang=js&"
export * from "./normalDialog.vue?vue&type=script&lang=js&"
import style0 from "./normalDialog.vue?vue&type=style&index=0&id=3e113bd8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e113bd8",
  null
  
)

export default component.exports